/*
 * Mutations
 */
export const ORDER_RETURN_SET_DEFAULT = 'order-return/setDefault';
export const ORDER_RETURN_SET_STATE = 'order-return/setState';
export const ORDER_RETURN_SET_ID = 'order-return/id';
export const ORDER_RETURN_SET_AUTHORIZATION = 'order-return/authorization';
export const ORDER_RETURN_SET_DRAFT_RA = 'order-return/draft/ra';
export const ORDER_RETURN_SET_DRAFT_REFUND = 'order-return/draft/refund';
export const ORDER_RETURN_SET_DRAFT_ORDER = 'order-return/draft/order';
export const ORDER_RETURN_SET_DISCOUNT = 'order-return/discount';
export const ORDER_RETURN_SET_LOADING = 'order-return/loading';
export const ORDER_RETURN_SET_LOGON = 'order-return/logOn';
export const ORDER_RETURN_SET_D365 = 'order-return/d365';
export const ORDER_RETURN_SET_LOGON_ERROR = 'order-return/logOn/error';
export const ORDER_RETURN_SET_D365_ERROR = 'order-return/d365/error';
export const ORDER_RETURN_SET_NOTE = 'order-return/note';
export const ORDER_RETURN_SET_NOTIFY = 'order-return/notify';
export const ORDER_RETURN_SET_ORDER = 'order-return/order';
export const ORDER_RETURN_SET_PRODUCTS = 'order-return/product';
export const ORDER_RETURN_SET_PRODUCT_ADD = 'order-return/product/add';
export const ORDER_RETURN_SET_PRODUCT_UPDATE = 'order-return/product/update';
export const ORDER_RETURN_SET_REASON_CODE = 'order-return/reasonCode';
export const ORDER_RETURN_SET_REASON_CODE_DETAIL = 'order-return/reasonCodeDetail'
export const ORDER_RETURN_SET_REGION = 'order-return/region';
export const ORDER_RETURN_SET_REMARKS = 'order-return/remarks';
export const ORDER_RETURN_SET_TEXT_REMARKS = 'order-return/text_remarks';
export const ORDER_RETURN_SET_SHIPPING = 'order-return/shipping';
export const ORDER_RETURN_SET_WAREHOUSE = 'order-return/warehouse';
export const ORDER_RETURN_SET_CONFIG = 'order-return/config'
export const ORDER_RETURN_SET_HIDE_BUTTON = 'order-return/hide_button'
/*
 * Actions
 */
export const ORDER_RETURN_RESET = 'order-return/reset';
export const ORDER_RETURN_CREATE_RA = 'order-return/createRA';
export const ORDER_RETURN_CREATE_DRAFT_RA = 'order-return/draft/createRA';
export const ORDER_RETURN_CREATE_SHOPIFY_REFUND = 'order-return/shopify/create/refund';
export const ORDER_RETURN_DISCOUNT_PRICE_RULE_ADD = 'order-return/discount/add';
export const ORDER_RETURN_DISCOUNT_FETCH_CODE = 'order-return/discount/fetch/code';
export const ORDER_RETURN_DISCOUNT_FETCH_FIXED = 'order-return/discount/fetch/fixed';
export const ORDER_RETURN_DISCOUNT_FETCH_PERCENT = 'order-return/discount/fetch/percent';
export const ORDER_RETURN_FULL_REFUND = 'order-return/fullRefund';
export const ORDER_RETURN_INIT = 'order-return/init';
export const ORDER_RETURN_FETCH = 'order-return/init/fetch';
export const ORDER_RETURN_PRODUCT_ADD = 'order-return/addProduct';
export const ORDER_RETURN_REFUND = 'order-return/getRefund';
export const ORDER_REFUND_REFUND_CALC_LINE_ITEMS = 'order-return/refund/calcLineItems';
export const ORDER_REFUND_REFUND_CALC_DISCOUNT = 'order-return/refund/calcDiscount';
export const ORDER_RETURN_SKIP_RA = 'order-return/skipRA';
/*
 * Getters
 */
export const ORDER_RETURN_IS_LOADED = 'order-return/hasOrder';
export const ORDER_RETURN_GET_AUTHORIZATION = 'order-return/ra';
export const ORDER_RETURN_GET_AUTHORIZATION_ITEMS = 'order-return/items';
export const ORDER_RETURN_GET_DISCOUNT_IS_APPLIED = 'order-return/discount/isApplied';
export const ORDER_RETURN_GET_DRAFT = 'order-return/draft';
export const ORDER_RETURN_GET_DRAFT_LINE_ITEMS = 'order-return/draft/lineItems';
export const ORDER_RETURN_GET_DRAFT_LINE_ITEMS_COUNT = 'order-return/draft/lineItems/count';
export const ORDER_RETURN_GET_DRAFT_LINE_ITEMS_DISCOUNT = 'order-return/draft/lineItems/discount';
export const ORDER_RETURN_GET_REFUND_DRAFT = 'order-return/refund/draft';
export const ORDER_RETURN_GET_REFUND_DRAFT_LINE_ITEMS = 'order-return/refund/draft/lineItems';
export const ORDER_RETURN_GET_REFUND_DRAFT_SHIPPING_LINE = 'order-return/refund/draft/shippingLine';
export const ORDER_RETURN_GET_ROUNDING_ERROR = 'order-return/rounding/error';
export const ORDER_RETURN_GET_DISCOUNT = 'order-return/discount'
